<template>
  <div>
    <v-text-field v-model="dateTime" clearable readonly persistent-clear :append-inner-icon="inputIcon" density="compact" :label="label" :placeholder="placeholder ? placeholder : label" @click:clear="handleDateClear()" :style="{ minWidth: '270px', maxWidth: width }" @click="dialog = true" variant="outlined" hide-details />
    <v-dialog class="remove-transition" v-model="dialog" width="450">
      <div @click="dialog = false" class="outer-wrap">
        <div @click.stop="dialog = true" class="wrapper rounded-lg bg-white">
            <v-row v-if="props.type != 'time'">
              <v-date-picker elevation="0" v-model="date" title="Select Date and Time" class="my-6 mx-auto" scrollable hide-actions no-title show-current :hide-header="true"></v-date-picker>
            </v-row>
            <v-row v-else><br></v-row>
            <v-row class="px-4" style="width: 380px; margin: auto;" v-if="props.type != 'date'">
              <v-col cols="6">
                <v-select :items="hours" v-model="selectedHour" label="Hour" density="compact"></v-select>
              </v-col>
              <v-col cols="6">
                <v-select :items="minutes" v-model="selectedMinute" label="Minutes" density="compact"></v-select>
              </v-col>
            </v-row>
          </div>
      </div>
    </v-dialog>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';
import moment from "moment";

const props = defineProps({
  label: {type: String, default: null },
    placeholder: { type: String, default: null },
  selected: { default: null },
  width: { type: String, default: '100%' },
  displayFormat: { type: String },
  format: { type: String, default: null },
  type: { type: String, default: null },
})
const dialog = ref(false);
const date = ref<any>(null);
const dateTime = ref<any>(null);
const inputIcon = ref('mdi-calendar');

const emit = defineEmits(['update:dateTime']);
let hours: any[] = Array.from({ length: 24 }, (_, x) => ({ title: (x < 10 ? '0' + x : '' + x).toString(), value: x }));
let minutes: any[] = Array.from({ length: 60 }, (_, i) => ({ title: (i < 10 ? '0' + i : '' + i).toString(), value: i }));
const selectedHour = ref<any>(moment().hour());
const selectedMinute = ref<any>(moment().minute());

onMounted(() => {
  // For time usage
  if(props.type === 'time') {
    inputIcon.value = 'mdi-clock';
    if(props.selected) { setTime();}
  } else if(props.type === 'date') {
    setDate();
  }else {
    if(props.selected) {
      setTime();
      setDate();
    }
  }
});

watch([selectedHour, selectedMinute, date], () => {
  let formatDate;
  if(props.type === 'time') {
    if(selectedHour.value !== null && selectedMinute.value !== null) {
      dateTime.value = moment().hour(selectedHour.value).minute(selectedMinute.value).format('LT');
      formatDate = moment(dateTime.value, 'LT').format(props.format ? props.format : 'YYYY-MM-DD HH:mm a');
    }
  } else if(props.type === 'date') {
    if(date.value) {
      dateTime.value = moment(date.value).format('MM/DD/YYYY');
      formatDate = moment(dateTime.value, 'MM/DD/YYYY').format(props.format ? props.format : 'YYYY-MM-DD HH:mm a');
    }
  } else {
    if(date.value) {
       selectedHour.value = selectedHour.value !== null ? selectedHour.value : moment().hour();
       selectedMinute.value = selectedMinute.value !== null ?  selectedMinute.value : moment().minute();
      dateTime.value = moment(date.value).hour(selectedHour.value).minute(selectedMinute.value).format('MM/DD/YYYY hh:mm a');
      formatDate = moment(dateTime.value, 'MM/DD/YYYY hh:mm a').format(props.format ? props.format : 'YYYY-MM-DD HH:mm a');
    }
  }
  emit('update:dateTime', formatDate);
});

function setTime() {
  const time = moment(props.selected,  "HH:mm:ss").format('LT');
  if(time !== 'Invalid date') {
    dateTime.value = time;
    selectedHour.value = moment(time, 'LT').hours();
    selectedMinute.value = moment(time, 'LT').minutes();
  }
}
function setDate() {
  if (props.selected) {
    const setdate = moment(props.selected, moment.ISO_8601, true).isValid() ? moment(props.selected) : moment(props.selected, props.format, true);
    dateTime.value = setdate.format('MM/DD/YYYY hh:mm a');
    if (setdate.isValid()) {
      selectedHour.value = setdate.hour();
      selectedMinute.value = setdate.minute();
      date.value = setdate.toDate();
    }
  }
}

function handleDateClear() {
  date.value = null;
  dateTime.value = null;
  selectedHour.value = 0;
  selectedMinute.value = 0;
}
</script>
<style scoped lang="scss">
:deep(.v-date-picker-header__append) {
  display: none;
}
.remove-transition {
  &:hover {
    background-color: transparent !important;
  }
}
.outer-wrap {
  background-color: transparent;
  box-shadow: none !important;
  &:hover {
    background-color: transparent !important;
  }
}
.wrapper {
  transform: scale(.8);
}
:deep(.v-date-picker__title) {
  font-size: 16px !important;
  font-weight: bold;
}
:deep(.v-date-picker-controls > .v-btn:first-child) {
  font-size:16px;
}
:deep(.v-date-picker-month__day) {
  font-size: 16px;
  font-weight: 700;
}
:deep(.v-btn__content) {
  font-size: 16px;
  font-weight: 700;
}
</style>